import React, { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
import { choiseMethodSizes, chioseMethodPaddingsRem, chioseMethodPaddingsPx, chioseMethodBorderRadiusesRem, chioseMethodBorderRadiusesPx } from '@shared/config/components/choiseMethod';
import { withTheme } from '@shared/lib/theme';
type SizeValue = keyof typeof choiseMethodSizes;
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
interface ChoiseMethodProps extends HTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'active';
  size?: ResponsiveSize;
  disabled?: boolean;
}
const ChoiseMethod: FC<PropsWithChildren<ChoiseMethodProps>> = ({
  variant = 'default',
  size = 'l',
  disabled = false,
  children,
  ...rest
}) => {
  const desktopSize = typeof size === 'object' ? size.desktop || 'l' : size || 'l';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 'l';
  return <ChoiseMethodWrapper type="button" variant={variant} desktopSize={desktopSize} mobileSize={mobileSize} disabled={disabled} {...rest}>
      {children}
    </ChoiseMethodWrapper>;
};
export default ChoiseMethod;
type ChoiseMethodWrapperProps = Required<Pick<ChoiseMethodProps, 'variant' | 'disabled'>> & {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp = /*#__PURE__*/() => ({
  desktopSize
}) => chioseMethodPaddingsRem[desktopSize];
const _exp2 = /*#__PURE__*/() => ({
  variant,
  theme
}) => variant === 'active' ? theme.colors.background.accent_30 : theme.colors.background.tertiary;
const _exp3 = /*#__PURE__*/() => ({
  variant,
  theme
}) => variant === 'active' ? theme.colors.stroke.active : 'transparent';
const _exp4 = /*#__PURE__*/() => ({
  desktopSize
}) => chioseMethodBorderRadiusesRem[desktopSize];
const _exp5 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? '0.5' : '1';
const _exp6 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'none' : 'auto';
const _exp7 = /*#__PURE__*/() => ({
  variant,
  theme
}) => variant === 'default' ? `inset 0 0 0 9999px ${theme.colors.background.hover}` : 'none';
const _exp8 = /*#__PURE__*/() => ({
  variant,
  theme
}) => variant === 'default' ? `inset 0 0 0 9999px ${theme.colors.background.hover}` : 'none';
const _exp9 = /*#__PURE__*/() => ({
  mobileSize
}) => chioseMethodPaddingsPx[mobileSize];
const _exp0 = /*#__PURE__*/() => ({
  mobileSize
}) => chioseMethodBorderRadiusesPx[mobileSize];
const ChoiseMethodWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "ChoiseMethodWrapper",
  class: "c1en3g3f",
  propsAsIs: false,
  vars: {
    "c1en3g3f-0": [_exp()],
    "c1en3g3f-1": [_exp2()],
    "c1en3g3f-2": [_exp3()],
    "c1en3g3f-3": [_exp4()],
    "c1en3g3f-4": [_exp5()],
    "c1en3g3f-5": [_exp6()],
    "c1en3g3f-6": [_exp7()],
    "c1en3g3f-7": [_exp8()],
    "c1en3g3f-8": [_exp9()],
    "c1en3g3f-9": [_exp0()]
  }
}));

require("./ChoiseMethod.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ChoiseMethod.tsx");